module.exports = __webpack_public_path__ + "img/李小玲.28e6f607.jpg";